<template>
    <div class="van-coupon item" @click="toDetail(id)">
        <div class="van-coupon__content">
            <van-row style="width:100%">
                <van-col :span="20">
                    <div class="title">{{ title }}</div>
                </van-col>
                <van-col :span="4">
                    <div class="tag">
                        {{ state==1 ? '可用' : '不可用' }}
                    </div>
                </van-col>
            </van-row>
            <div class="body">
                {{begindate}}至{{enddate}}
            </div>
        </div>
    </div>
</template>

<script>
import { Tag, Cell, Panel, Row, Col } from 'vant';

export default {
    name: "PackageItem",
    components: {
        [Cell.name]: Cell,
        [Panel.name]: Panel,
        [Tag.name]: Tag,
        [Row.name]: Row,
        [Col.name]: Col
    },
    props: ['title', 'begindate', 'enddate', 'state', 'id'],
    data() {
        return {}
    },
    mounted(){},
    methods: {
        toDetail(id){
            console.log(id)
            this.$router.push(`/nt/user/dinnercarddetail/${id}`)
        },
    }
}
</script>

<style lang="less" scoped>
    .van-coupon {
        margin-top: 1em;
        background-color: #203864;
        .van-coupon__content {
            margin-top: 8px;
            padding-left: 1em;
            padding-right: 1em;
            display: block;

            .title {
                font-size: 1em;
                font-weight: bold;
                color: #D8D8D8;
            }

            .body {
                margin-top: 1em;
                font-size: 0.8em;
                color: #D8D8D8;
            }

            .tag {
                height: 24px;
                color: #B5D0F9;
            }
        }
    }


</style>